import { subscribeMessage } from "Config/natsClient";
import * as motion from "motion/react-client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTarget } from "slice/allTargetSlice";
import { getstreamingBackgroundGetImagePersonFace } from "slice/streamingBackgroundGetImagePersonFaceSlice";
import { getstreamingBackgroundGetImageStreaming } from "slice/streamingBackgroundGetImageStreamingSlice";
import { getTargetIsDpo } from "slice/targetIsDpoSlice";
import { getTarget } from "slice/targetSlice";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import { createMediaMTXWebRTCReader } from "Config/migrasiReader";
import { useRef } from "react";
import _ from "lodash";
import DpoAlert from "./DpoAlert";

export const Video = () => {
  const dispatch = useDispatch();
  const hasRetriedRef = useRef(false);
  const valueCamera = useSelector((state) => state.realtime.selected);
  const targetIsDpo = useSelector((state) => state.targetIsDpo.data || []);
  const target = useSelector((state) => state.target.data || []);
  const camera = useSelector((state) => state.realtime.selectedCamera);
  const { isConnected, isError, errorMessage, isSubscribed } = useSelector(
    (state) => state.statusNats
  );

  const [mergedData, setMergedData] = useState([]);
  const [mergedDataIsDpo, setMergedDataIsDpo] = useState([]);
  const [mergedDataAllTarget, setMergedDataAllTarget] = useState([]);
  const [message, setMessage] = useState("");
  const [query, setQuery] = useState(window.location.search);
  const [loadingState, setLoadingState] = useState(false);
  const [errorState, setErrorState] = useState(false);
  // console.log(mergedDataIsDpo, 'mergedDataIsDpo')

  const suscribe = valueCamera?.id;
  // console.log(suscribe, 'Idsuscribe')
  useEffect(() => {
    // if (!isSubscribed) return;
    const callback = async (data) => {
      // console.log(data, 'data')
      if (!data?.uuid || !data?.uuid_person || data?.similarity <= 0.7) {
        // console.log("Similarity terlalu rendah, tidak melakukan request.");
        return;
      }

      try {
        const [backgroundRes, personFaceRes] = await Promise.all([
          dispatch(
            getstreamingBackgroundGetImageStreaming({
              page: 0,
              size: 99,
              uuid_person_fr: data.uuid,
            })
          ).unwrap(),
          dispatch(
            getstreamingBackgroundGetImagePersonFace({
              page: 0,
              size: 99,
              uuid_person_fr: data.uuid_person,
            })
          ).unwrap(),
        ]);

        if (!backgroundRes || !personFaceRes) return;

        if (data?.uuid_person !== backgroundRes?.uuid_person_fr) {
          console.log("UUID tidak cocok, data tidak diproses.");
          return;
        }
        // console.log(backgroundRes, "backgroundRes");
        const personFaceArray = Array.isArray(personFaceRes)
          ? personFaceRes.data
          : [personFaceRes];

        const processedData = personFaceArray.map((person) => ({
          uuid_person: data.uuid_person,
          backgroundRes: backgroundRes?.data || null,
          personFaceRes: person.image || null,
          fullName: person.fullName || null,
          id: person.id || null,
          nik: person.nik || null,
          dateOfBirth: person?.dateOfBirth || null,
          placeOfBirth: person?.placeOfBirth || null,
          isActive: person?.isActive || null,
          isDpo: person?.isDpo || null,
          timestamp: data?.timestamp || null,
          image: data?.image,
          similarity: backgroundRes?.similarity || null,
        }));

        const newMergedData = processedData.filter(
          (person) => person.similarity > 0.55 && !person.isDpo
        );
        const newMergedDataIsDpo = processedData.filter(
          (person) => person.similarity > 0.55 && person.isDpo
        );
        const newMergedDataAllTarget = processedData.filter(
          (person) => person.similarity > 0.55
        );

        const updateMergedData = (prev, newData) =>
          prev.some((item) => item.uuid_person === data.uuid_person)
            ? prev.map((item) =>
                item.uuid_person === data.uuid_person
                  ? { ...item, ...newData[0] }
                  : item
              )
            : [...prev, ...newData];

        setMergedData((prev) => {
          const updatedData = updateMergedData(prev, newMergedData);
          dispatch(getTarget(updatedData));
          return updatedData;
        });

        setMergedDataIsDpo((prev) => {
          const updatedData = updateMergedData(prev, newMergedDataIsDpo);
          dispatch(getTargetIsDpo(updatedData));
          return updatedData;
        });

        setMergedDataAllTarget((prev) => {
          const updatedData = updateMergedData(prev, newMergedDataAllTarget);
          dispatch(getAllTarget(updatedData));
          return updatedData;
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const unsubscribe = subscribeMessage(suscribe, callback);
    // dispatch(setConnected());
    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
        // console.log('masukk')
        // dispatch(setDisconnected());
      }
    };
  }, [dispatch, valueCamera?.id]);

  useEffect(() => {
    // dispatch(cleardataIpCamList([]));
    setLoadingState(true);
    const reader = createMediaMTXWebRTCReader({
      url: new URL("whep", `${camera.ip_address}/${query}`),
      onError: (err) => {
        setErrorState(true);
        console.error("Streaming error:", err);
        setMessage(err.toString());
        setLoadingState(false);
      },
      onTrack: (evt) => {
        setErrorState(false);
        setMessage("");
        setLoadingState(false);
      },
    });

    // return () => {
    //   reader.close();
    // };
  }, [query, camera.ip_address]);

  // useEffect(() => {
  //   unsubscribeMessage(subs);
  // }, []);

  // console.log(img, "img");

  useEffect(() => {
    if (isError && !hasRetriedRef.current) {
      // console.log("kepanggil 1");
      initializeStream(camera);
      hasRetriedRef.current = true; // Cegah pemanggilan ulang
    }
  }, [isError, camera]);

  useEffect(() => {
    setMergedDataIsDpo([]);
    setMergedData([]);
  }, [valueCamera?.id]);

  useEffect(() => {
    const handleURLChange = () => setQuery(window.location.search);
    window.addEventListener("popstate", handleURLChange);
    return () => window.removeEventListener("popstate", handleURLChange);
  }, []);

  const initializeStream = (camera) => {
    setLoadingState(true);
    const reader = createMediaMTXWebRTCReader({
      url: new URL("whep", `${camera.ip_address}/${query}`),
      onError: (err) => {
        setErrorState(true);
        console.error("Streaming error:", err);
        setMessage(err.toString());
        setLoadingState(false);
      },
      onTrack: (evt) => {
        setErrorState(false);
        setMessage("");
        setLoadingState(false);
      },
    });
  };

  const [queue, setQueue] = useState([]); // Hanya berisi 1 alert aktif
  const [pendingQueue, setPendingQueue] = useState([]); // Data baru menunggu giliran
  const displayedIds = useRef(new Set());
  const isPausedRef = useRef(false);
  const [isPaused, setIsPaused] = useState(false);

  // Menambahkan data baru ke pendingQueue, bukan langsung ke queue
  useEffect(() => {
    if (mergedDataIsDpo.length > 0) {
      const newItems = mergedDataIsDpo.filter(
        (item) => !displayedIds.current.has(item.id)
      );

      if (newItems.length > 0) {
        newItems.forEach((item) => displayedIds.current.add(item.id));
        setPendingQueue((prev) => [...prev, ...newItems]); // Masukkan ke antrian tunggu
      }
    }
  }, [mergedDataIsDpo]);

  // Menampilkan 1 alert pada satu waktu
  useEffect(() => {
    if (queue.length === 0 && pendingQueue.length > 0) {
      setQueue([pendingQueue[0]]); // Ambil 1 item dari pendingQueue ke queue
      setPendingQueue((prev) => prev.slice(1)); // Hapus item pertama dari pendingQueue
    }
  }, [queue, pendingQueue]);

  // Handle close, setelah alert tertutup, tampilkan alert berikutnya
  const handleClose = () => {
    setQueue([]); // Hapus alert aktif
  };

  return (
    <motion.div
      // style={ball}
      key={camera?.ip_address}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div
        className={`text-white w-full h-full gap-4 ${errorState ? "cursor-pointer" : ""} `}
        onClick={() => {
          if (errorState) {
            initializeStream(camera);
          }
        }}
      >
        <div className="relative ">
          <div className="absolute inset-0 pointer-events-none ">
            <div className="absolute top-0 z-10 w-full border-t-2 border-mo-button"></div>
            <div className="absolute bottom-0 z-10 w-full border-b-2 border-mo-button"></div>
            <div className="absolute left-0 z-10 h-full border-l-2 border-mo-button"></div>
            <div className="absolute right-0 z-10 h-full border-r-2 border-mo-button"></div>
          </div>
          <div className="absolute inset-0 pointer-events-none ">
            <div className="absolute top-0 left-0 z-20 w-4 h-4 border-t-4 border-l-4 border-mo-text"></div>
            <div className="absolute top-0 right-0 z-20 w-4 h-4 border-t-4 border-r-4 border-mo-text"></div>
            <div className="absolute bottom-0 left-0 z-20 w-4 h-4 border-b-4 border-l-4 border-mo-text"></div>
            <div className="absolute bottom-0 right-0 z-20 w-4 h-4 border-b-4 border-r-4 border-mo-text"></div>
          </div>
          <div className="flex bg-black p-5 gap-4 h-custom-heights">
            <div className={` flex flex-col h-full w-full overflow-hidden`}>
              <div className="flex justify-between mb-2">
                <div className="flex items-center gap-2">
                  {/* {isConnected && <p style={{ color: "green" }}>✅ Terhubung</p>}
                {isError && (
                  <p style={{ color: "red" }}>❌ Error: {errorMessage}</p>
                )}
                {!isConnected && !isError && (
                  <p style={{ color: "orange" }}>⚠️ Belum terhubung</p>
                )} */}
                  <img
                    src={
                      loadingState
                        ? "/asset/EllipseYellow.svg" // Loading
                        : errorState
                          ? "/asset/Ellipse.svg" // Error
                          : "/asset/EllipseGreen.svg" // Success
                    }
                    width={20}
                    alt="Icon"
                  />
                  <div>{camera.device_name}</div>
                </div>
                <div className="flex gap-2">
                  {loadingState ? (
                    <img
                      className=""
                      src="/asset/loadBall.gif"
                      width={20}
                      // height={10}
                      alt="Live Icon"
                    />
                  ) : errorState ? (
                    <VideocamOffIcon color="error" />
                  ) : (
                    <img src="/asset/live.svg" width={80} alt="Live Icon" /> // Jika sukses, tampilkan ikon "live"
                  )}
                </div>
              </div>
              <div className="flex flex-col items-center h-full grow-0 justify-center ">
                {camera ? (
                  <div className="relative w-full max-w-full h-full max-h-full">
                    {camera && (
                      <div className="text-center text-black absolute  flex items-center justify-center top-0 bottom-0 w-full h-custom-video">
                        {!errorState && !loadingState ? (
                          <iframe
                            src={camera?.ip_address}
                            className="absolute w-full h-full"
                            style={{
                              border: "none",
                              objectFit: "cover",
                              // pointerEvents: 'none'
                            }}
                            sandbox="allow-same-origin allow-scripts"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                          />
                        ) : (
                          <div className="absolute flex flex-col items-center justify-center">
                            <h1 className="font-bold text-white mb-10">
                              {loadingState ? (
                                <img
                                  className=""
                                  src="/asset/loadBall.gif"
                                  width={50}
                                  // height={10}
                                  alt="Live Icon"
                                />
                              ) : errorState ? (
                                <div className="w-full h-full flex flex-col justify-center items-center">
                                  <img
                                    src="/asset/fluent_plug-disconnected.svg"
                                    alt="Disconnected"
                                    className="mb-4 w-20 h-w-20"
                                  />
                                  <div className="text-xl">Kamera Terputus</div>
                                </div>
                              ) : (
                                <>
                                  <div>Menghubungkan</div>
                                </>
                              )}
                            </h1>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center text-black bg-stone-200 flex flex-col items-center justify-center top-0 bottom-0 w-full h-full">
                    <div className="text-center text-black font-semibold left-0 right-0">
                      No cam selected.
                    </div>
                    <p className="font-light mt-2 text-sm">
                      Select camera to start monitoring.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {queue?.map((alert, idx) => (
        <DpoAlert
          key={alert?.id}
          index={idx}
          data={alert}
          onClose={handleClose}
          setIsPaused={setIsPaused}
          isPaused={isPaused}
        />
      ))}
    </motion.div>
  );
};
